import * as actionTypes from '../actionTypes';
import { getAllCategories } from '../../api/apiUrls/categories';

const getCategoriesStart = () => ({ type: actionTypes.GET_CATEGORIES_START });
const getCategoriesSuccess = (payload) => ({ type: actionTypes.GET_CATEGORIES_SUCCESS, payload });
const getCategoriesFail = () => ({ type: actionTypes.GET_CATEGORIES_FAIL });

const getCategories = () => (dispatch) => {
  dispatch(getCategoriesStart());

  return getAllCategories()
    .then(({ data }) => {
      dispatch(getCategoriesSuccess(data));
    })
    .catch((error) => {
      dispatch(getCategoriesFail(error));
    });
};

const categoriesActions = {
  getCategories,
};

export default categoriesActions;
